import React from 'react'
import { Grid, Table } from 'semantic-ui-react'
import { Button, Label, Header, Segment, Icon} from 'semantic-ui-react'



export default class StatisticUser extends React.Component {
    state = {open: false,
        played_game:0,
        victory_number:0,
        last_game_date:null,
        last_victory: null,
        last_score:null,
        last_position:null,
        best_score:null,
        best_placing:null,
        max_quote: null,
        max_bet:null,
        blackanswer_number:0,
        last_blackanswer_date:null,
        average_bet:null,
        average_answer_time:null,
        total_money:0}

    componentDidMount() {
        if (this.props.onMount)
            this.props.onMount()
        this.setState({
                    open: true,
                    played_game:this.props.exp_user.played_game,
                    victory_number:this.props.exp_user.victory_number,
                    last_game_date:this.props.exp_user.last_game_date,
                    last_victory:this.props.exp_user.last_victory,
                    last_score:this.props.exp_user.last_score,
                    last_position:this.props.exp_user.last_position,
                    best_score:this.props.exp_user.best_score,
                    best_placing:this.props.exp_user.best_placing,
                    max_quote: this.props.exp_user.max_quote,
                    max_bet:this.props.exp_user.max_bet,
                    blackanswer_number:this.props.exp_user.blackanswer_number,
                    last_blackanswer_date:this.props.exp_user.last_blackanswer_date,
                    average_bet:this.props.exp_user.average_bet,
                    average_answer_time:this.props.exp_user.average_answer_time,
                    total_money:this.props.exp_user.total_money
                })
    }

    componentDidUpdate(prevProps) {
        if (prevProps.user !== this.props.user){
            if (this.props.onMount)
                 this.props.onMount()
             if (this.props.exp_user){
                  const exp_user = this.props.exp_user;
                  this.setState({
                        open: true,
                        played_game:exp_user.played_game,
                        victory_number:exp_user.victory_number,
                        last_game_date:exp_user.last_game_date,
                        last_victory:exp_user.last_victory,
                        last_score:exp_user.last_score,
                        last_position:exp_user.last_position,
                        best_score:exp_user.best_score,
                        best_placing:exp_user.best_placing,
                        max_quote: exp_user.max_quote,
                        max_bet:exp_user.max_bet,
                        blackanswer_number:exp_user.blackanswer_number,
                        last_blackanswer_date:exp_user.last_blackanswer_date,
                        average_bet:exp_user.average_bet,
                        average_answer_time:exp_user.average_answer_time,
                        total_money:exp_user.total_money
                    })
                }
        }
    }

    handleClose = ()  => this.setState({open: false});


    render(){
            if (!this.state.open) return null;
           return(<Segment>
              <div style={{ textAlign: 'center' }}>
              <Header color ='yellow'>Ecco le tue statistiche fino a questo momento*.</Header>
              <Table striped celled>
              <tbody>
                <Table.Row >
                <Table.Cell >
                    <Grid columns = {2}>
                    <Grid.Column textAlign='center' floated='left'>
                    <Label style={{fontSize: '13px'}} horizontal color = 'purple' >Numero partite</Label>  
                    </Grid.Column>
                    <Grid.Column floated='left' textAlign='center'>
                    {this.state.played_game}
                    </Grid.Column>
                    </Grid>
                </Table.Cell>
                <Table.Cell>
                <Grid columns = {2}>
                    <Grid.Column textAlign='center'>
                    <Label style={{fontSize: '13px'}} horizontal  color = 'purple'>Numero vittorie</Label>  
                    </Grid.Column>
                    <Grid.Column floated='left' textAlign='center'>
                    {this.state.victory_number}                   
                    </Grid.Column>
                    </Grid>
                </Table.Cell>                     
                </Table.Row>
                <Table.Row>
                <Table.Cell>
                <Grid columns = {2}>
                    <Grid.Column textAlign='center'>
                    <Label style={{fontSize: '13px'}} horizontal color = 'purple' >Ultima partita</Label>  
                    </Grid.Column>
                    <Grid.Column floated='left' textAlign='center'>
                    {this.state.last_game_date?new Date(this.state.last_game_date).toLocaleDateString():'N.A.'}  
                    </Grid.Column>
                    </Grid>
                </Table.Cell>                     
                <Table.Cell>
                <Grid columns = {2}>
                  <Grid.Column textAlign='center'>
                    <Label style={{fontSize: '13px'}} horizontal color = 'purple' >Ultima vittoria</Label>  
                    </Grid.Column>
                    <Grid.Column floated='left' textAlign='center'>
                    {this.state.last_victory?new Date(this.state.last_victory).toLocaleDateString():'N.A.'}  
                    </Grid.Column>
                </Grid>
                </Table.Cell>
                </Table.Row>
                <Table.Row>
                <Table.Cell>
                <Grid columns = {2}>
                    <Grid.Column textAlign='center'>
                    <Label style={{fontSize: '13px'}} horizontal color = 'purple' >Ultimo punteggio</Label>  
                    </Grid.Column>
                    <Grid.Column floated='left' textAlign='center'>
                    {this.state.last_score?this.state.last_score:'N.A.'} 
                    </Grid.Column>
                    </Grid>
                </Table.Cell>                     
                <Table.Cell>
                <Grid columns = {2}>
                <Grid.Column textAlign='center'>
                    <Label style={{fontSize: '13px'}} horizontal color = 'purple' >Ultimo piazzamento</Label>  
                    </Grid.Column>
                    <Grid.Column floated='left' textAlign='center'>
                    {this.state.last_position?this.state.last_position:'N.A.'} 
                    </Grid.Column>
                </Grid>
                </Table.Cell>                      
                </Table.Row>
                <Table.Row>
                <Table.Cell>
                <Grid columns = {2}>
                    <Grid.Column textAlign='center'>
                    <Label style={{fontSize: '13px'}} horizontal color = 'purple' >Miglior punteggio</Label>  
                    </Grid.Column>
                    <Grid.Column floated='left' textAlign='center'>
                    {this.state.best_score?this.state.best_score:'N.A.'} 
                    </Grid.Column>
                    </Grid>
                </Table.Cell>                     
                <Table.Cell>
                <Grid columns = {2}>
                   <Grid.Column textAlign='center'>
                    <Label style={{fontSize: '13px'}} horizontal color = 'purple' >Miglior piazzamento</Label>  
                    </Grid.Column>
                    <Grid.Column floated='left' textAlign='center'>
                    {this.state.best_placing?this.state.best_placing:'N.A.'} 
                    </Grid.Column>
                </Grid>
                </Table.Cell>
                </Table.Row>
                <Table.Row>
                <Table.Cell>
                <Grid columns = {2}>
                    <Grid.Column textAlign='center'>
                    <Label style={{fontSize: '13px'}} horizontal color = 'purple' >Migliore quota</Label>  
                    </Grid.Column>
                    <Grid.Column floated='left' textAlign='center'>
                    {this.state.max_quote?this.state.max_quote:'N.A.'} 
                    </Grid.Column>
                    </Grid>
                </Table.Cell>                     
                <Table.Cell>
                <Grid columns = {2}>
                   <Grid.Column textAlign='center'>
                    <Label style={{fontSize: '13px'}} horizontal color = 'purple' >Massima puntata</Label>  
                    </Grid.Column>
                    <Grid.Column floated='left' textAlign='center'>
                    {this.state.max_bet?this.state.max_bet:'N.A.'} 
                    </Grid.Column>
                </Grid>
                </Table.Cell>                      
                </Table.Row>
                <Table.Row>
                <Table.Cell>
                    <Grid columns = {2}>
                    <Grid.Column textAlign='center'>
                    <Label style={{fontSize: '13px'}} horizontal color = 'black' >Numero Black Answer</Label>  
                    </Grid.Column>
                    <Grid.Column floated='left' textAlign='center'>
                    {this.state.blackanswer_number} 
                    </Grid.Column>
                    </Grid>
                </Table.Cell>
                <Table.Cell>
                <Grid columns = {2}>
                    <Grid.Column textAlign='center'>
                    <Label style={{fontSize: '13px'}} horizontal  color = 'black'>Ultima Black Answer</Label>  
                    </Grid.Column>
                    <Grid.Column floated='left' textAlign='center'>
                    {this.state.last_blackanswer_date?new Date(this.state.last_blackanswer_date).toLocaleDateString():'N.A.'}  
                    </Grid.Column>
                    </Grid>
                </Table.Cell>                     
                </Table.Row>
                <Table.Row>
                <Table.Cell>
                    <Grid columns = {2}>
                    <Grid.Column textAlign='center'>
                    <Label style={{fontSize: '13px'}} horizontal color = 'purple' >Puntata media</Label>  
                    </Grid.Column>
                    <Grid.Column floated='left' textAlign='center'>
                    {this.state.average_bet?this.state.average_bet:'N.A.'} 
                    </Grid.Column>
                    </Grid>
                </Table.Cell>
                <Table.Cell>
                <Grid columns = {2}>
                    <Grid.Column textAlign='center'>
                    <Label horizontal  color = 'purple'>Tempo medio di risposta</Label>  
                    </Grid.Column>
                    <Grid.Column floated='left' textAlign='center'>
                    {this.state.average_answer_time?(this.state.average_answer_time/1000).toFixed(2):'N.A.'} s 
                    </Grid.Column>
                    </Grid>
                </Table.Cell>                     
                </Table.Row>
                </tbody>
              </Table>
              <Segment><Icon  name='money bill alternate'  size = 'big'/> Soldi guadagnati finora:    <font style={{ color: 'yellow' }}> {this.state.total_money} euro</font></Segment>
              <Button content='Chiudi' negative  onClick={this.handleClose} />
              <Header as ='h6' textAlign='right'> *Le statistiche vengono aggiornate alla fine della partita</Header>
              </div>
            </Segment>)
        }
}




// WEBPACK FOOTER //
// ./src/components/StatisticUser.js